
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2.667C8.636 2.667 2.667 8.637 2.667 16c0 7.364 5.97 13.333 13.333 13.333 7.364 0 13.333-5.97 13.333-13.333A13.33 13.33 0 0016 2.667zm0 24C10.109 26.667 5.333 21.89 5.333 16S10.11 5.333 16 5.333 26.667 10.11 26.667 16A10.667 10.667 0 0116 26.667zm4.12-14.08l-.707-.707a.638.638 0 00-.933 0L16 14.347l-2.48-2.467a.64.64 0 00-.933 0l-.707.707a.638.638 0 000 .933L14.347 16l-2.467 2.48a.64.64 0 000 .933l.707.707a.638.638 0 00.933 0L16 17.653l2.48 2.467a.64.64 0 00.933 0l.707-.707a.638.638 0 000-.933L17.653 16l2.467-2.48a.64.64 0 000-.933z"}})])
          )
        }
      }
    